var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"retargeting-partner",style:({ ..._vm.cssVars }),on:{"click":_vm.goToPartner}},[_c('app-asset',{staticClass:"asset",class:_vm.white ? 'asset--white' : '',attrs:{"version":"v3","name":_vm.assetName,"title":_vm.title,"alt":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }